module.exports = __webpack_public_path__ + "img/sana_n.17bef5df.png";